

import React, {Component}from 'react';
import { scaleBand, scaleLinear } from 'd3-scale';
import Axes from './Axes';
import VBars from "./VBars";
import Tooltip from "./Tooltip";
import ChartComponent from "./ChartComponent";



class Chart extends Component {
    constructor(props) {
        super(props);
        this.yScale = scaleBand();
        this.xScale = scaleLinear();

        this.state = {
            datatorender:[],
            clicked: false,
            processed: true,
            hoveredData: false,
            hovering: false,
            selectedData: false,
            filterAction:false,
        }
    }


    // to move
    filterData(datum){
        this.props.handleFilter(datum.key,datum.d);
        this.setState({selectedData:datum, clicked:true})
    }

    render() {

        if (this.state.processed) {

            let data= this.props.initData;
            const margins = {top: 10, right: 30, bottom: 10, left: 70};
            const svgDimensions = {
                width: Math.max(this.props.parentWidth, 150),
                height: 80
            };

            const maxValue = Math.max(...data.map(d => d.value));

            const yScale = this.yScale
                .padding(0.1)
                .domain(data.map(d => d.d))
                .range([svgDimensions.height - margins.bottom, margins.top]);

            // scaleLinear type
            const xScale = this.xScale
                .domain([0, maxValue + 5])
                .range([margins.left, svgDimensions.width - margins.right]);


            return (
                <div className="Chart">
                    <svg width={svgDimensions.width} height={svgDimensions.height}>
                        <Axes
                            scales={{xScale, yScale}}
                            margins={margins}
                            svgDimensions={svgDimensions}
                        />
                       <VBars
                            scales={{xScale, yScale}}
                            margins={margins}
                            data={this.props.data}
                            initData = {this.props.initData}
                            color={"default"}
                            maxValue={maxValue}
                            svgDimensions={svgDimensions}
                            hoveredData = {this.state.hoveredData}
                            hovering = {this.state.hovering}
                            clicked = {this.state.clicked}
                            selectedData = {this.state.selectedData}
                            onMouseOverCallback={datum => {
                                this.setState({hoveredData: datum, hovering:true})}}
                            onMouseOutCallback={datum => this.setState({hoveredData: false, hovering:false})}
                            onMouseClickCallback={datum => { this.filterData(datum);}}
                        />

                    </svg>
                    { this.state.hoveredData ?
                        <Tooltip
                            hoveredBar={this.state.hoveredData}
                            scales={{ xScale, yScale }}
                        /> : null
                    }

                </div>
            )
        }
    else
        {
            return (<div>Processing data</div>)
        }
    }
}


export default ChartComponent(Chart)